var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mt-1 mb-1"},[_c('span',{staticClass:"w-1/2 font-semibold mr-4"},[_vm._t("default")],2),_c('span',{staticClass:"w-1/2 dark-grey"},[_vm._t("value",[_vm._v(" "+_vm._s(_vm.value)+" ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }